import React, { useEffect, useRef, useState } from "react";
import DynamicActionBar from "../Common/DynamicActionBar";
import { useDispatch, useSelector } from "react-redux";
import {
  hasImage,
  isTrueFalse,
  removeFirstAndLastThreeChars,
  removeFirstAndLastThreeCharsparagraph,
  replaceMathTagWithAltText,
} from "../helper";
import html2pdf from "html2pdf.js";
import { useNavigate } from "react-router-dom";
import { Modal } from "../Common/Modal";
import EditModel from "../Component/Pdf/EditModel";
import { ACTIONS } from "../redux/actions";
import jsPDF from "jspdf";
import pdfMake from "pdfmake/build/pdfmake";
import { Api } from "../Service/api";
import { ErrorToast } from "../Common/Toast";
import PrintModel from "../Common/PrintModel";
import { HeadersPath, path } from "../Utils/ScreenPath";
import moment from "moment/moment";
import { PDFDocument, rgb, degrees, StandardFonts } from 'pdf-lib';
import fontkit from "@pdf-lib/fontkit";
import gujaratiFontUrl from "../assets/Font/NotoSansGujarati-Regular.ttf";
import axios from "axios";
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { config } from "../Service/api/configuration/config";



pdfMake.fonts = {
  Arial: {
    normal: "Arial.ttf",
    bold: "Arial-Bold.ttf",
  },
};

const replaceMarkersInTable = (html, startId) => {
  if (!html) return html;
  let result = html;
  const startNum = parseInt(startId, 10);
  const matches = html.match(/\(x\d+\)\./g);
  if (matches) {
    matches.forEach((match) => {
      const idx = parseInt(match.match(/\d+/)[0], 10);
      const replacement = `${startNum + idx - 1}.`;
      const regex = new RegExp(`\\(x${idx}\\)\\.`, 'g');
      result = result.replace(regex, replacement);
    });
  }
  return result;
};

const PdfPreview = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const examData = useSelector((state) => state?.SelectedDetail?.Data);
  console.log("examData", examData);
  const lastPaperId = useSelector((state) => state?.PaperId?.paperId);
  const [isModelOpen, setisModelOpen] = useState(false);
  const [fontSize, setFontSize] = useState(examData?.font_size || 18);
  const [headingTextSize, setHeadingTextSize] = useState(
    examData?.heading_size || 22
  );
  const [watermarkItemSize, setWatermarkItemSize] = useState(
    examData?.watermark_size || 25
  );
  const [watermarkItemOpacity, setWatermarkItemOpacity] = useState(
    examData?.watermark_opacity || 50
  );
  const [accountTableFontSize, setAccountTableFontSize] = useState(
    examData?.account_table_font_size || 18
  );
  const [isModelPrintOpen, setisModelPrintOpen] = useState(false);
  const [modifiedPdfUrl, setModifiedPdfUrl] = useState("");
  const [modelCall, setModelCall] = useState(false);
  const [dualPaperView, setDualPaperView] = useState(examData?.dualPaperView ?? examData?.isAccessDualPaper ?? false);



  useEffect(() => {
    if (examData?.dualPaperView !== undefined) {
      setDualPaperView(examData?.dualPaperView);
    }
  }, [examData?.dualPaperView]);

  useEffect(() => {
    if (examData?.account_table_font_size) {
      setAccountTableFontSize(examData?.account_table_font_size);
    }
  }, [examData?.account_table_font_size]);
  const fontFamily = ['Times New Roman', 'Arial', 'Courier New'];
  const overAllFontSize = examData?.font_size || 18;
  const headingSize = examData?.heading_size || 22;
  const watermarkSize = examData?.watermark_size || 25;
  const watermarkOpacity = examData?.watermark_opacity || 50;

  // Check if HTML content contains id="accounttable"
  const hasAccountTable = examData?.sections_info?.some(section =>
    section?.divisions?.some(division =>
      division?.question_data?.some(question =>
        (question?.finalquestion || question?.question || '').includes('id="accounttable"') ||
        (question?.finalAnswer || '').includes('id="accounttable"')
      )
    )
  ) || false;

  const paperType = examData?.paperType;

  const isExamPaperExamdate =
    (examData?.paperType === 0 || examData?.paperType === 1) &&
    examData?.exam_date;

  const isWithSection = examData?.genrate_type == "with section" ? true : false;

  const htmlContentDemo = `
  <html>
  <head>
    
  <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Exam Paper</title>
    <script src="https://polyfill.io/v3/polyfill.min.js?features=es6"></script>
    <script id="MathJax-script" async src="https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js"></script>


    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/katex.min.css" integrity="sha384-n8MVd4RsNIU0tAv4ct0nTaAbDJwPJzDEaqSD1odI+WdtXRGWt2kTvGFasHpSy3SV" crossorigin="anonymous">
    <script src="https://polyfill.io/v3/polyfill.min.js?features=es6"></script>
      <script id="MathJax-script" async
              src="https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js">
      </script>
  
      <style>
       
       body {
        }
        
        .body-class {
          font-family: ${fontFamily};
      }

      @page {
          padding: 20px 20px;
        
        }
      * {
        box-sizing: border-box;
      }
      @media print {
        * {
            animation: none !important;
            transition: none !important;
          }
      }
       h1, h2, h3, h4, h5, h6 {
        color: #000000;
        font-family: ${fontFamily};
        font-size: ${overAllFontSize}px;
        margin: 4px;
      }
      ol, ul {
        list-style: none;
        padding: 0px;
        margin: 0px;
        font-family: ${fontFamily};
      }
      li {
        margin-bottom: 4px;
        font-family: ${fontFamily};
      }
      .exam-title {
        color: #000000;
        align-self: center;
        display: flex;
        font-family: ${fontFamily};
        font-size: ${overAllFontSize}px;
        margin: 0px;
      }
      .center-div {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .parent {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .random_genrate_notice {
        font-size: ${overAllFontSize}px;
        font-weight: bold;
        color: #000000;
        font-family: ${fontFamily};
        padding: 4px; 
        margin: 0 0 0 0;
      }
      p {
        font-family: ${fontFamily} !important;
        font-size: ${overAllFontSize}px !important;
        margin: 4px 0 ;
        padding: 4px 0 ;
        text-align: justify;
      }
     
      td, th {
        font-family: ${fontFamily} !important;
        font-size: ${overAllFontSize}px !important;
      }
      
      ${hasAccountTable ? `
      /* Fix accounttable font size - user can change via button, but not affected by general font size */
      table[id="accounttable"] td,
      table[id="accounttable"] th,
      table[id="accounttable"] p,
      table[id="accounttable"] div,
      table[id="accounttable"] span {
        font-size: ${accountTableFontSize}px !important;
      }
      
      /* Remove all internal borders from accounttable */
      table[id="accounttable"] td,
      table[id="accounttable"] th {
        border: none !important;
      }
      
      /* Add border for header row (first row) - only main accounttable */
      table[id="accounttable"][border="1"] > tbody > tr:first-child td,
      table[id="accounttable"][border="1"] > tbody > tr:first-child th {
        border-top: 1px solid #000 !important;
        border-bottom: 1px solid #000 !important;
      }
      
      /* Add border for footer row (last row) - only main accounttable */
      table[id="accounttable"][border="1"] > tbody > tr:last-child td,
      table[id="accounttable"][border="1"] > tbody > tr:last-child th {
        border-top: 1px solid #000 !important;
        border-bottom: 1px solid #000 !important;
      }
      
      /* Add vertical borders between columns - only main accounttable */
      table[id="accounttable"][border="1"] > tbody > tr > td:not(:last-child),
      table[id="accounttable"][border="1"] > tbody > tr > th:not(:last-child) {
        border-right: 1px solid #000 !important;
      }
      
      /* Outer border - only main accounttable */
      table[id="accounttable"][border="1"] {
        border-collapse: collapse !important;
        border: 1px solid #000 !important;
        width: 100% !important;
      }
      ` : ''}
      
      div {
        font-family: ${fontFamily} !important;
        font-size: ${overAllFontSize}px !important;
      }
      span {
        font-family: ${fontFamily} !important;
        font-size: ${overAllFontSize}px !important;
      }
      .options {
        display: flex;
        flex-wrap: wrap;
        font-family: ${fontFamily};
        font-size: ${overAllFontSize}px;
        padding: 0 0 0 20px;
        margin: 5px 0 0 0;
      }
      .option {
        width: 100%; /* Adjust as needed */

      }
      table[border="1"] {
        border: 1px solid black; /* Apply the border styling */
        border-collapse: collapse; /* Make sure borders do not double */
      }

      table[border="1"] td {
        border: 1px solid black; /* Apply border styling to table cells */
      }

      table[border="0"] td {
        border: 0px solid black; /* Apply border styling to table cells */
      }
      .question-container {
        display: flex;
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 0 0 4px 0;
        padding: 0 0;

      }
      .question-column  {
        width: 40%;
        border: 1px solid #000;
        box-sizing: border-box ;
        font-family: ${fontFamily};
        font-size: ${overAllFontSize}px;
        background-color: #ffffff;
        margin: 0 0 0 0;
        padding: 0 0 0 0;
        
      }
      .question-column .pppp {
        
        text-align: center; 
        alingn-items: center;
        padding: 0 1px 0 1px !important; 
      }
      .answer-column  {
        width: 20%;
        border: 1px solid #000;
        box-sizing: border-box ;
        font-family: ${fontFamily};
        font-size: ${overAllFontSize}px;
        background-color: #ffffff;
        margin: 0 0 0 0;
        padding: 0 0 0 0;
      }
      .answer-column .pppp {
        
        text-align: center; 
        alingn-items: center;
        padding: 0 1px 0 1px !important; 
      }
      .last-message{
        color: #444444;
        font-size: 30px !important;
        display: flex;
        align-items: center;
        justify-content: center;
        margin:24px 0 0 0 ;
        font-family: 'Sofia', sans-serif
      }
      .two-column-layout {
        column-count: 2;
        column-gap: 30px;
        column-rule: 1px solid black;
        width: 100%;
      }
      .two-column-layout section {
        break-inside: auto;
      }
      img, table {
        max-width: 100% !important;
        height: auto !important;
      }
      table {
        word-wrap: break-word;
      }
      .question-content {
        overflow: hidden;
        min-width: 0;
        max-width: 100%;
      }
      .question-content img {
        display: block;
        margin: 10px auto;
        max-width: 90%;
      }
      .option-image {
        max-width: 70px;
        max-height: 80px;
        margin: 0 4px;
        flex-shrink: 0;
        object-fit: contain;
      }


    </style>
  </head>
  <body>
  <div class="body-class">
      <div style="display: flex; align-items: center;  flex-direction: column; justify-content: center;">
        ${examData?.institute_logo
      ? `
          <img src="${examData?.institute_logo}" alt="Logo" style="width: 800px; height: 100px !important; margin-bottom: 8px;" />
        `
      : `
          <h1 style="color: 'red'; margin-bottom: 0px; font-size: ${headingSize}px; display:flex; flex:1; text-align:center; justify-content: center; width: 90%;">${examData.school_name}</h1>
        `
    }
    </div>
    
    <hr>
    <div>
      <div class="parent">
      <p class="exam-title">Subject: ${examData?.subject_name}</p>
      ${examData?.exam_name &&
    `<p class="exam-title"> ${examData?.exam_name}</p>`
    }
      ${isExamPaperExamdate
      ? `<p class="exam-title" id="subject-name">Date: ${moment(
        examData?.exam_date
      ).format("DD-MM-YYYY")}</p>`
      : ``
    }
       
    </div>
      <div class="parent">
      <p class="exam-title">Standard: ${examData?.standard_name}</p>
       
    ${examData.exam_marks
      ? `<p class="exam-title" id="subject-name">Marks: ${examData.exam_marks?.length == 1
        ? "0" + examData.exam_marks
        : examData.exam_marks
      }</p>`
      : ``
    }
    </div>
    <div class="parent">
    ${examData.chapter_name &&
    `
    <p class="exam-title">Chapter: ${examData.chapter_name}</p>
    `
    }
    ${examData?.exam_time?.trim() && examData?.exam_time != undefined
      ? `
      <p class="exam-title" id="subject-name">Exam Time: ${examData?.exam_time}</p>
      `
      : ""
    }
   
    </div>
    </div>

    <hr>
    <div class="${dualPaperView ? 'two-column-layout' : ''}">
    ${examData?.sections_info
      ?.map(
        (section) => `<section>
        ${isWithSection && section.section_name
            ? `<div style="display: flex; align-items: center; justify-content: center;">
        
        <h2 style="text-align: center; text-decoration: underline; font-family: ${fontFamily}; font-size: ${overAllFontSize}px">${section.section_name}</h2>
        </div>`
            : ""
          }

        ${section?.sectionNotice ? `<div style="display: flex; justify-content: flex-start; align-items: center; flex-direction: row; padding: 0px; margin: 0px; font-weight: bold;">
            <p class="random_genrate_notice">\u2023 &nbsp;</p>
            <p style="margin=0 0 0 0; padding: 0 0 0 0">${section?.sectionNotice ?? ""} </p>
          </div>`    : ""}
          


      ${section?.divisions
            ?.map(
              (division) =>
                `
        <div style="display: flex; justify-content: space-between; align-items: center; flex-direction: row; padding: 0px; margin: 0px" >
        ${!division?.random_genrate_notice
                  ? ""
                  : `<div style='display:flex; flex-direction:row'>
        <p class="random_genrate_notice">\u2023 &nbsp;</p>
        <p class="random_genrate_notice">${division.questionTitle ? division.questionTitle : ""
                  } ${division.questionTitle ? "-" : ""} ${division.random_genrate_notice
                  }</p>
        </p> 
        </div>
        <p style="font-size: ${overAllFontSize}px padding: 0 0 0 0; margin: 0 0 0 0">(${division.marks.length == 1
                    ? "0" + division.marks
                    : division.marks
                  })</p> 
        `
                }
        </div>
        ${!division?.random_genrate_notice
                  ? ""
                  : `
            <div style="min-height: fit-content; padding: 0 0 0 0; margin: 0 0 0 0">
        <ol>
          ${division?.question_data
                    ?.map((question, _index) => {
                      // if (question.isOr) {
                      //   orIndex += 1;
                      // }

                      const getAnswers = () => {
                        const indexOfAnswer = question?.finalAnswers?.findIndex(
                          option =>
                            option.imgAnswers == question?.finalAnswer ||
                            option.answer == question?.finalAnswer,
                        );
                        if (
                          question?.finalAnswers?.some(
                            (answer) => answer.imgAnswers == question?.finalAnswer
                          )
                        ) {
                          return `<img src="${question?.finalAnswer}" alt="" style="max-width: 70px; max-height: 80px; margin: 0 5px" resize="contain"/>`;
                        }
                        return `
                   ${`(${String.fromCharCode(indexOfAnswer + 65)}) ${question?.finalAnswer
                          }`}
                  ${question?.finalAnswers.filter(
                            (answer) =>
                              answer.answer == question?.finalAnswer &&
                              answer.imgAnswers
                          ).length > 0
                            ? question?.finalAnswers
                              ?.filter(
                                (answer) => answer.answer == question?.finalAnswer
                              )
                              .map((answer) => {
                                return `
                        <img src="${answer?.imgAnswers}" alt="" style="width: 70px; height: 80px;" resize="contain"/>`;
                              })
                              .join("")
                            : ""
                          }
                 
                  `;
                        // return `<img src="${question?.finalAnswer}" alt="" style="width: 70px; height: 80px;" resize="contain"/>`;
                      };


                      const question_id =
                        question?.question_id > 0 && (question?.andId || 0) <= 1
                          ? `${Number(question?.question_id)
                            .toString()
                            .padStart(2, '0')}.${question?.andId
                              ? `&nbsp;(${String.fromCharCode((question?.andId || 0) + 96)})`
                              : ''
                          }`
                          : question?.question_id > 0
                            ? `(${String.fromCharCode((question?.andId || 0) + 96)})`
                            : `${paperType == 2
                              ? `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;`
                              : question?.question_id == 0 && _index > 99
                                ? `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;`
                                : `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;`
                            }`;





                      let maxLength = question.finalAnswers
                        ? Math.max(
                          ...question.finalAnswers.map((obj) => {
                            // Strip HTML tags for length calculation
                            let text = obj.answer?.replace(/\u003c[^\u003e]*\u003e/g, '') || '';

                            // Remove common HTML entities
                            text = text.replace(/&nbsp;/g, ' ')
                              .replace(/&lt;/g, '\u003c')
                              .replace(/&gt;/g, '\u003e')
                              .replace(/&amp;/g, '&')
                              .trim();

                            return text.length;
                          })
                        )
                        : 0;

                      // Updated 3-tier layout system for MCQ options:
                      // - Very short options (≤10 chars): 25% width = 4 options per line
                      // - Standard options (11-40 chars): 50% width = 2 options per line
                      // - Long options (>40 chars): 100% width = 1 option per line
                      let optionWidth = "100%"; // default for long options
                      if (maxLength <= 10) {
                        optionWidth = "25%"; // 4 options in single line
                      } else if (maxLength <= 40) {
                        optionWidth = "50%"; // 2 options in single line (most common)
                      }

                      return `
              ${(question?.questionLeft || question?.questionRight) &&
                          !question.paragraph
                          ? ""
                          : (question?.isOr && question?.paragraph)
                            ? `<p style="font-size: ${overAllFontSize}px; display: flex; align-items: center; justify-content: center; margin:0; padding:0 0 6px 0;">OR</p>`
                            : (question?.isOr && !question?.subID)
                              ? `<p style="font-size: ${overAllFontSize}px; display: flex; align-items: center; justify-content: center; margin:0; padding:0 0 6px 0;">OR</p>`
                              : ""
                        }
            ${(question?.isInsideTable && !question?.paragraph) ? "" : `
            <li style="${question?.questionLeft ? "margin: 0px" : ""}">
            ${question?.paragraph
                            ? (/<table/i.test(question?.paragraph)
                              ? `<div style="padding: 0 0 5px 35px; margin:0; text-align: justify;">${removeFirstAndLastThreeCharsparagraph(
                                replaceMarkersInTable(question?.paragraph, question?.question_id)
                              )}</div>`
                              : `<p style="padding: 0 0 5px 35px; margin:0; text-align: justify;">${removeFirstAndLastThreeCharsparagraph(
                                replaceMarkersInTable(question?.paragraph, question?.question_id)
                              )}</p>`)
                            : ""
                          }
            ${!question.isInsideTable ? `
            ${question?.questionLeft || question?.questionRight
                              ? `




                ${(question?.questionLeft || question?.questionRight) &&
                                question?.paragraph
                                ? `<div class="question-container">
                
                ${false
                                  ? ""
                                  : `
                <p style="padding-right: 7px">${question?.question_id > 99
                                    ? `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;`
                                    : `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;`
                                  }</p>`
                                }
                <div class="question-column">
                <p class="pppp" >${(section?.sectionNotice?.toLowerCase().includes("rectify") ||
                                  division?.random_genrate_notice?.toLowerCase().includes("rectify") ||
                                  division?.questionTitle?.toLowerCase().includes("rectify")) ? 'Error' : 'A'}</p>
                 
                </div>
                <div class="question-column">
                <p class="pppp">${(section?.sectionNotice?.toLowerCase().includes("rectify") ||
                                  division?.random_genrate_notice?.toLowerCase().includes("rectify") ||
                                  division?.questionTitle?.toLowerCase().includes("rectify")) ? 'Correction' : 'B'}</p>
                </div>


                ${paperType == 2 && question?.rightAnswer
                                  ? `
                <div class="answer-column">
                <p class="pppp">Answer</p>
                </div>
                `
                                  : ""
                                }
              </div>`
                                : ""
                              }






                <div class="question-container">
                
                ${question.isOr
                                ? ""
                                : `
                <p style="padding-right: 7px">${question_id}
                                  </p>`
                              }
                <div class="question-column">
                ${question?.questionLeft
                                ? `<p style="padding-left: 8px">${question?.questionLeft}</p>`
                                : ``
                              }
                </div>
                <div class="question-column">
                ${question?.questionRight
                                ? `<p style="padding-left: 8px">${question?.questionRight}</p>`
                                : ""
                              }
                </div>


                ${paperType == 2
                                ? `
                <div class="answer-column">
                ${question?.questionRight && question?.rightAnswer
                                  ? `<p style="padding-left: 8px"; class="pppp">${paperType == 2
                                    ? question?.rightAnswer
                                    : question?.questionRight
                                  }</p>`
                                  : ""
                                }
                </div>
                `
                                : ""
                              }
              </div>
            `
                              : `
              ${!question?.isInsideTable ? `
              <div style='display:flex; flex-direction:row; min-width: 0; overflow: hidden; margin: 0 0 0 ${question?.andId > 1 ? `${overAllFontSize + 8}px` : "0"
                                }'>
                <p style="
                  padding: 0 0 0 ${question?.subID ? "5px" : "0"};
                  margin: 0 0 0 ${question?.subID ? "5px" : "0"};
                  ${paperType == 2 ? "font-weight: 700" : ""}
                ">
             
                ${question_id}</p>
                <div style='padding :0 0 0 0; margin: 0 0 0 5px; min-width: 0; overflow: hidden; ${paperType == 2 ? "font-weight: 700" : ""
                                }'>
              

                <div class="question-content" style='padding : 0 ; margin: 0;  font-size: ${overAllFontSize}px ${paperType == 2 ? "font-weight: 700" : ""
                                }'>
                ${question?.qtype != 1 ||
                                  hasImage(question?.finalquestion || question?.question)
                                  ? removeFirstAndLastThreeChars(
                                    question?.finalquestion || question?.question
                                  )
                                  : removeFirstAndLastThreeChars(
                                    question?.finalquestion || question?.question
                                  )
                                    ?.replace(/<br>/g, "")
                                    ?.replace(/</g, "&lt")
                                    ?.replace(/>/g, "&gt")

                                // .replace(/\\/g, ``)
                                }
                  </div>
                </div>
            </div>
            ` : ""}
                  `
                            }
              ${!question.isInsideTable && question?.finalAnswers?.length > 0
                              ? `
              <ol class="options" >
         
                  ${(question?.finalAnswers?.[0]?.answer
                                ? question?.finalAnswers
                                : question?.answers
                              )

                                .map((answer, index) => {
                                  return `
                      <div style='display:flex; justify-content:flex-start; align-items:flex-start; width: ${optionWidth}; white-space: ${maxLength > 20 ? "normal" : "nowrap"}; overflow: hidden;'>
                        <li style="margin:0 5px; flex-shrink: 0;">${String.fromCharCode(
                                    65 + index
                                  )}.&nbsp;</li>
                        <li class="option" style="display:flex; flex-direction:row; flex: 1; overflow: hidden; text-overflow: ellipsis;"> ${
                                    // question.html_tag == 1 ||
                                    // (question?.html_question == 1 &&
                                    question.qtype != 1 || hasImage(answer?.answer || "")
                                      ? removeFirstAndLastThreeChars(answer?.answer || "")
                                      : removeFirstAndLastThreeChars(answer?.answer || "")
                                        ?.replace(/<br>/g, "")
                                        ?.replace(/</g, "&lt")
                                        ?.replace(/>/g, "&gt")
                                    }
                       ${answer?.imgAnswers
                                      ? `<img src="${answer?.imgAnswers}" class="option-image" resize="contain"/>`
                                      : ""
                                    } </li>
                      </div>
                    `;
                                })
                                .join("")}


            
                  
              </ol>
            `
                              : ""
                            }
              ${!question?.isInsideTable && paperType == 2
                              ? `
                ${!(question?.questionLeft || question?.questionRight)
                                ? `
                    <div style='display:flex; flex-direction:row'>
               <p style=' margin: 4px 0 4px 0;'>
                <span style="font-weight: 700">
                Ans. 
                </span>
                </p>
                ${question?.qtype != "12"
                                  ? `
                    <div style="">
                <p style="text-align: justify;  margin: 4px 0 4px 0;  flex-direction:row;"> &nbsp;
                ${question?.qtype == "1"
                                    ? getAnswers()
                                    : question?.qtype != "1" || hasImage(question?.finalAnswer)
                                      ? removeFirstAndLastThreeChars(isTrueFalse(question))
                                      : removeFirstAndLastThreeChars(
                                        isTrueFalse(question)
                                          ?.replace(/</g, "&lt")
                                          ?.replace(/>/g, "&gt")
                                      )
                                  // removeFirstAndLastThreeChars(isTrueFalse(question))
                                  }
                </p>
                
                </div>
              `
                                  : ``
                                }
                

                </div>
                 ${!question?.isInsideTable && question?.qtype == "12"
                                  ? `<div>

                     ${question?.perfact_metch
                                    .map((item, _index) => {
                                      return `
                    <div class="question-container">
                    <div class="question-column">
                    ${item?.finalquestion ? `<p>${item?.finalquestion}</p>` : ""
                                        }
                    
                    </div>
                    <div class="question-column">
                    ${item?.finalanswer ? `<p>${item?.finalanswer}</p>` : ""}
                    </div>
                  </div>
                    `;
                                    })
                                    .join("")}
                        </div>`
                                  : ""
                                } 
                `
                                : ``
                              }
                `
                              : ``
                            }
` : ""}

              ${!question.isInsideTable && paperType == 3 &&
                            !(question?.questionLeft || question?.questionRight)
                            ? `
                  <div>
                  <div style="display: flex; flex-direction: row;">
                  <div style="">
                    <h2>Ans</h2>
                  </div>
                  <div style="flex: 1; border-bottom: 1.5px dashed black" />
                </div>
                </div>
              <div style="margin-left: 40px">
                ${question?.QtypeInfo?.worksheet_space > 1
                              ? `
                  ${Array.from({
                                length: Number(question?.QtypeInfo?.worksheet_space - 1),
                              })
                                .map(
                                  (_, _index) => `
                  <div >
                  <div style="flex: 1; padding: 10px; border-bottom: 1.5px dashed black;" />
                  </div>
                  `
                                )
                                .join("")}
                `
                              : ``
                            }
                </div>
                `
                            : ``
                          }

            </li>` }
          `;
                    })
                    .join("")}
        </ol>
        </div>
        `
                }
        `
            )
            .join("")}
    </section>
   
    `
      )
      .join("")}
    </div>

     
${paperType == 1 || paperType == 3
      ? ` ${paperType == 1 || paperType == 3
        ? examData?.last_message &&
        `<p class="last-message">${examData?.last_message} </p>  `
        : ""
      }
      <div style="page-break-before: always;" />

      <div style="display: flex; align-items: center;  flex-direction: column; margin-top: 1px">
          <h1 style="margin-bottom: 0px; ">ANSWERS</h1>
    </div>
    
    <hr>
    <div>
    <div class="parent">
    <p class="exam-title">Subject: ${examData?.subject_name}</p>
    ${examData?.exam_name && `<p class="exam-title"> ${examData?.exam_name}</p>`
      }

    ${isExamPaperExamdate
        ? `<p class="exam-title" id="subject-name">Date: ${moment(
          examData?.exam_date
        ).format("DD-MM-YYYY")}</p>`
        : ``
      }
     
  </div>
    <div class="parent">
    <p class="exam-title">Standard: ${examData?.standard_name}</p>
  ${examData?.exam_marks
        ? `<p class="exam-title" id="subject-name">Marks: ${examData.exam_marks?.length == 1
          ? "0" + examData.exam_marks
          : examData.exam_marks
        }</p>`
        : ``
      }
  </div>
  <div class="parent">
  ${examData?.chapter_name &&
      `
  <p class="exam-title">Chapter: ${examData?.chapter_name}</p>
  `
      }
  ${examData?.exam_time?.trim() && examData?.exam_time != undefined
        ? `
    <p class="exam-title" id="subject-name">Exam Time: ${examData.exam_time}</p>
    `
        : ""
      }
 
  </div>
    </div>

    <hr>
    ${examData?.sections_info
        ?.map(
          (section) => `<section>
        ${isWithSection && section?.section_name
              ? `<div style="display: flex; align-items: center; justify-content: center;">
        
        <h2 style="text-align: center; text-decoration: underline; font-family: ${fontFamily}; font-size: ${overAllFontSize}px">${section.section_name}</h2>
        </div>`
              : ""
            }
      
      ${section?.divisions
              ?.map(
                (division) =>
                  `
        <div style="display: flex; justify-content: space-between; align-items: center; flex-direction: row; padding: 0px; margin: 0px" >
        ${!division.random_genrate_notice
                    ? ""
                    : `
        <p class="random_genrate_notice">\u2023 ${division.random_genrate_notice
                    }</p> 
        <p style="font-size: ${overAllFontSize}px padding: 4px; margin: 4px">(${division.marks.length == 1
                      ? "0" + division.marks
                      : division.marks
                    })</p> 
        `
                  }
        </div>
        ${!division?.random_genrate_notice
                    ? ""
                    : `
        <ol>
          ${division?.question_data
                      ?.map((question, _index) => {
                        const getAnswers = () => {
                          const indexOfAnswer = question?.finalAnswers?.findIndex(
                            option =>
                              option.imgAnswers == question?.finalAnswer ||
                              option.answer == question?.finalAnswer,
                          );
                          if (
                            question?.finalAnswers?.some(
                              (answer) => answer.imgAnswers == question?.finalAnswer
                            )
                          ) {
                            return `<img src="${question?.finalAnswer}" alt="" style="max-width: 70px; max-height: 80px; margin: 0 4px" resize="contain"/>`;
                          }
                          return `
                  ${question?.qtype == '1' && !hasImage(question?.finalAnswer)
                              ? `(${String.fromCharCode(
                                indexOfAnswer + 65,
                              )}) ${removeFirstAndLastThreeChars(
                                isTrueFalse(question)
                                  ?.replace(/</g, '&lt')
                                  ?.replace(/>/g, '&gt'),
                              )}`
                              : `(${String.fromCharCode(indexOfAnswer + 65)}) ${question?.finalAnswer
                              }`
                            }
                  ${question?.finalAnswers?.filter(
                              (answer) =>
                                answer?.answer == question?.finalAnswer &&
                                answer?.imgAnswers
                            ).length > 0
                              ? question?.finalAnswers
                                ?.filter(
                                  (answer) => answer.answer == question?.finalAnswer
                                )
                                .map((answer) => {
                                  return `
                        <img src="${answer?.imgAnswers}" alt="" style="max-width: 70px; max-height: 80px;margin: 0 4px" resize="contain"/>`;
                                })
                                .join("")
                              : ""
                            }
                 
                  `;
                          // return `<img src="${question?.finalAnswer}" alt="" style="width: 70px; height: 80px;" resize="contain"/>`;
                        };

                        const question_id =
                          question?.question_id > 0 && (question?.andId || 0) <= 1
                            ? `${Number(question?.question_id)
                              .toString()
                              .padStart(2, '0')}.${(question?.andId || 0)
                                ? `&nbsp;(${String.fromCharCode((question?.andId || 0) + 96)})`
                                : ''
                            }`
                            : question?.question_id > 0
                              ? `(${String.fromCharCode((question?.andId || 0) + 96)})`
                              : `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;`;
                        if (question?.question_id == 0) return ``;
                        return `
              ${(question?.questionLeft || question?.questionRight) &&
                            !question.paragraph
                            ? ""
                            : question.isOr
                              ? `<p style="font-size: ${overAllFontSize}px; display: flex; align-items: center; justify-content: center; margin:0; padding:0;">OR</p>`
                              : ""
                          }
            <li style="${question?.questionLeft ? "margin: 0px" : ""}">
            <div style='display:flex; flex-direction:row; min-width: 0; overflow: hidden; margin: 0 0 0 ${question?.andId > 1 ? `${overAllFontSize + 8}px` : "0"
                          }'>
            <p style="
                  padding: 0 0 0 ${question?.subID ? "5px" : "0"};
                  margin: 0 0 0 ${question?.subID ? "5px" : "0"};
                  font-size: ${overAllFontSize}px;
                ">
             
                ${
                          // (question?.questionLeft || question?.questionRight) &&
                          // !question.paragraph
                          //   ? ''
                          //   :
                          question_id
                          }</p><p style='padding : 0; margin: 0 0 0 5px'>
                <div>
                ${question?.qtype != "12"
                            ? `
                <p style='padding : 0; margin: 0; font-size: ${overAllFontSize}px'>
               ${
                            //  question.finalAnswers?.[0]?.answer ||
                            //  question?.answers?.[0]?.answer
                            //    ? (question.finalAnswers?.[0]?.answer
                            //        ? question.finalAnswers
                            //        : question.answers)[Number(question?.ans_option)]?.answer
                            //    :
                            //  removeFirstAndLastThreeChars(isTrueFalse(question))

                            question?.qtype == "1"
                              ? getAnswers()
                              : question?.qtype != "1" || hasImage(question?.finalAnswer)
                                ? removeFirstAndLastThreeChars(isTrueFalse(question))
                                : removeFirstAndLastThreeChars(
                                  isTrueFalse(question)
                                    ?.replace(/</g, "&lt")
                                    ?.replace(/>/g, "&gt")
                                )
                            }

             
               </p>
                `
                            : ``
                          }
                </div>
                  </p> 
                  ${question?.qtype == "12"
                            ? `<div>
                      ${question?.perfact_metch
                              .map((item, _index) => {
                                return `
                    <div class="question-container">
                    <div class="question-column">
                    ${item?.finalquestion ? `<p>${item?.finalquestion}</p>` : ""
                                  }
                    
                    </div>
                    <div class="question-column">
                    ${item?.finalanswer ? `<p>${item?.finalanswer}</p>` : ""}
                    </div>
                  </div>
                    `;
                              })
                              .join("")}
                      </div>`
                            : ""
                          }
              </div>
            </li>
          `;
                      })
                      .join("")}
        </ol>
        `
                  }
        `
              )
              .join("")}
    </section>
    `
        )
        .join("")}

      `
      : ""
    }
${examData?.last_message
      ? `<p class="last-message">${examData?.last_message}</p> `
      : ""
    }

  </div>
  </body>
  </html>
`;

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleModelPrintClose = () => {
    setModelCall(true);
    setisModelPrintOpen(!isModelPrintOpen);
  };

  const getImageBase64 = async (imageUrl) => {
    try {
      const response = await fetch(`${config.baseURL}/get-image-base64?url=${encodeURIComponent(imageUrl)}`);
      const data = await response.json();

      // Remove "data:image/*;base64," part if needed
      const base64 = data.base64?.split(',')[1]; // safely handle missing values

      return base64;
    } catch (error) {
      console.error('Error fetching base64 from backend:', error);
      return null;
    }
  };


  useEffect(() => {
    generatePDF();
  }, [examData, dualPaperView]);



  const handleDownload = async () => {
    dispatch(ACTIONS.startLoading())
    try {
      // Create a shallow copy to prevent mutating the Redux state
      const examDataCopy = { ...examData };

      delete examDataCopy.board;
      delete examDataCopy.isPageNumber;
      delete examDataCopy.id;
      delete examDataCopy.user_id;
      delete examDataCopy.deleted;
      delete examDataCopy.dualPaperView; // Remove dualPaperView - we'll send isAccessDualPaper instead

      let body = {
        id: lastPaperId || "",
        data: JSON.stringify({
          ...examDataCopy,
          sections_info: JSON.stringify(examData?.sections_info),
          finalsections_info: JSON.stringify(examData?.sections_info),
          font_size: overAllFontSize,
          pdf_url: " ",
          waterMarkUrl: examData?.waterMarkUrl,
          watermark_size: watermarkSize.toFixed(0),
          watermark_opacity: watermarkOpacity.toFixed(0),
          heading_size: headingSize,
          last_message: examData?.last_message || "",
          // Send isAccessDualPaper instead of dualPaperView (backend requirement)
          isAccessDualPaper: dualPaperView ? 1 : 0,
          account_table_font_size: accountTableFontSize,
        }),
      };
      if (lastPaperId) {
        // Update the paper with new settings (e.g. font size) before downloading
        await Api.UpdatePaper(body);

        const link = document.createElement('a');
        link.href = modifiedPdfUrl;
        link.download = `${examData?.subject_name}-${examData?.standard_name}-${'Youth Education'}-${new Date().getTime()}.pdf`;
        link.click();
        navigate(path?.PaperHistory);
      } else {
        const { data } = await Api.CreatePaper(body?.data);
        const res = JSON.parse(data);
        if (res?.status === 200) {
          const link = document.createElement('a');
          link.href = modifiedPdfUrl;
          link.download = `${examData?.subject_name}-${examData?.standard_name}-${'Youth Education'}-${new Date().getTime()}.pdf`;
          link.click();

          navigate(path?.PaperHistory);
          dispatch(ACTIONS.GetPaperId(res?.data?.question?.id || ""));
        } else {
          ErrorToast(res?.message);
        }
      }
    } catch (e) {
      ErrorToast(e);
    } finally {
      dispatch(ACTIONS.stopLoading())
    }
  };

  const handleEdit = () => {
    setisModelOpen(!isModelOpen);
  };


  const handleModelClose = () => {
    setisModelOpen(!isModelOpen);
  };

  const handleOperPaperEditScreen = () => {
    navigate(path?.EditPaper);
  };


  async function addPageNumbersToBlob(blob) {
    try {
      const arrayBuffer = await blob.arrayBuffer();
      const pdfDoc = await PDFDocument.load(arrayBuffer);
      // Use a Unicode (Gujarati-capable) font for footer/watermark/page-number
      // stamping. The built-in Helvetica only supports Latin characters, so any
      // Gujarati footer/watermark text would throw and blank the whole PDF.
      let font;
      try {
        pdfDoc.registerFontkit(fontkit);
        const gujaratiFontBytes = await fetch(gujaratiFontUrl).then((r) => r.arrayBuffer());
        font = await pdfDoc.embedFont(gujaratiFontBytes, { subset: true });
      } catch (fontErr) {
        console.error('Gujarati font embed failed, falling back to Helvetica:', fontErr);
        font = await pdfDoc.embedFont(StandardFonts.Helvetica);
      }

      const isLink = examData?.waterMarkUrl?.includes('https://');

      let imageBytes

      if (isLink) {

        await getImageBase64(examData?.waterMarkUrl).then(base64 => {
          if (base64) {
            imageBytes = base64
          }
        });

      }

      for (let i = 0; i < pdfDoc.getPageCount(); i++) {
        const page = pdfDoc.getPage(i);
        const { width, height } = page.getSize();
        const pageNumberText = `Page ${i + 1}`;
        const textWidth = font.widthOfTextAtSize(pageNumberText, 12);

        if (examData.isborder) {
          page.drawRectangle({
            x: 10,
            y: 10,
            width: width - 20,
            height: height - 20,
            borderWidth: 1,
            borderColor: rgb(0, 0, 0),
          });
        }

        if (examData.footerText) {
          page.drawText(examData.footerText, {
            x: 28,
            y: 15,
            size: 10,
            font: font,
            color: rgb(0, 0, 0),
          });
        }

        if (examData?.waterMarkUrl) {
          // console.log('PaperData?.waterMarkUrl-==-=-', PaperData?.waterMarkUrl);
          const fontSize = 36; // Adjust as needed

          if (isLink) {
            let image;

            try {
              image = await pdfDoc.embedPng(imageBytes);
            } catch (error) {
              console.error(
                'Failed to embed image as PNG. Trying JPG...',
                error,
              );
            }

            if (!image) {
              try {
                image = await pdfDoc.embedJpg(imageBytes);
              } catch (error) {
                console.error('Failed to embed image as JPG.', error);
                return null;
              }
            }
            const imgSize = watermarkSize * 3;
            page.drawImage(image, {
              x: (width - imgSize) / 2,
              y: (height - imgSize) / 2,
              width: imgSize,
              height: imgSize,
              opacity: watermarkOpacity / 100,
            });
          } else {

            const textWidth = font.widthOfTextAtSize(examData?.waterMarkUrl, fontSize);
            const textHeight = font.heightAtSize(fontSize);


            console.log('textWidth :>> ', textWidth);

            let textwid = textWidth > (width / 2) ? textWidth / 2 : textWidth;

            // Calculate position to center rotated text
            const x = (width - textwid) / 2 + 30;
            const y = (height - textHeight) / 2;



            page.drawText(examData?.waterMarkUrl, {
              x,
              y,
              size: +(watermarkSize * 1).toFixed(0),
              font,
              color: rgb(0, 0, 0),
              opacity: watermarkOpacity / 100,
              rotate: degrees(45),
              maxWidth: width / 2,
              lineHeight: 55,
            });
          }
        }

        if (examData?.isPageNumber) {
          page.drawText(pageNumberText, {
            x: width - textWidth - 25,
            y: 15,
            size: 10,
            font,
            color: rgb(0, 0, 0),
          });
        }
      }

      const modifiedPdfBytes = await pdfDoc.save();
      return new Blob([modifiedPdfBytes], { type: 'application/pdf' });
    } catch (error) {
      // Don't lose the whole paper if stamping fails — return the original PDF
      // (without footer/watermark/page-number) so the user still gets output.
      console.error('Error adding page numbers/watermark:', error);
      return blob;
    }
  }

  const generatePDF = async () => {
    const htmlContent = htmlContentDemo;
    console.log('htmlContent :>> ', htmlContent);
    try {
      dispatch(ACTIONS.startLoading());
      const response = await axios.post(`${config.baseURL}/generate-pdf`, {
        html: htmlContent
      }, {
        responseType: 'blob', // Important for receiving PDF file
      });

      const originalBlob = new Blob([response.data], { type: 'application/pdf' });
      // const originalBlob = new Blob([htmlContent], { type: 'application/pdf' });


      const modifiedBlob = await addPageNumbersToBlob(originalBlob);

      // Show in browser or download
      const modifiedUrl = URL.createObjectURL(modifiedBlob);

      setModifiedPdfUrl(modifiedUrl);

    } catch (error) {
      console.error('PDF generation failed:', error);
    } finally {
      dispatch(ACTIONS.stopLoading());
    }

  };


  const handleModelapply = () => {
    const modelData = {
      ...examData,
      font_size: fontSize,
      heading_size: headingTextSize,
      watermark_size: watermarkItemSize,
      watermark_opacity: watermarkItemOpacity,
      account_table_font_size: accountTableFontSize,
      dualPaperView: dualPaperView ? 1 : 0,
    };
    if (lastPaperId) {
      // localStorage.setItem(`account_table_font_size_${lastPaperId}`, accountTableFontSize);
    }
    dispatch(ACTIONS.getSelectedData(modelData));
    setisModelOpen(!isModelOpen);
  };
  const actions = [
    { label: "Edit Paper", isBordered: true, onClick: handleOperPaperEditScreen },
    { label: "Edit", isBordered: true, onClick: handleEdit },
    { label: "Save & Download", onClick: handleDownload },
  ];

  return (
    <div>
      <DynamicActionBar
        showArrowLeft
        backButtonLabel={"Preview Paper"}
        onBackClick={handleBackClick}
        actions={actions}
      />
      {/* <div
        id="paper"
        ref={contentRef}
        dangerouslySetInnerHTML={{ __html: htmlContentDemo }}
      /> */}

      {/* {modifiedPdfUrl && (
        <iframe
          src={modifiedPdfUrl}
          width="100%"
          height="700px"
          title="PDF Preview"
          style={{ border: 'none' }}

        />
      )} */}
      {modifiedPdfUrl && (
        <div style={{ display: "flex", justifyContent: "center", width: "auto", alignContent: "center", backgroundColor: "#fff" }}>
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
            <Viewer fileUrl={modifiedPdfUrl}
              enableSmoothScroll
              defaultScale={1.5}
            />
          </Worker>
        </div>
      )}

      <Modal
        title="Edit Paper"
        buttonText="Apply"
        width="max-w-2xl"
        modalOpen={isModelOpen}
        onApply={handleModelapply}
        onClose={handleModelClose}
      >
        <EditModel
          fontSize={fontSize}
          setFontSize={setFontSize}
          headingTextSize={headingTextSize}
          setHeadingTextSize={setHeadingTextSize}
          watermarkSize={watermarkItemSize}
          setWatermarkSize={setWatermarkItemSize}
          watermarkOpacity={watermarkItemOpacity}
          setWatermarkOpacity={setWatermarkItemOpacity}
          accountTableFontSize={accountTableFontSize}
          setAccountTableFontSize={setAccountTableFontSize}
          hasAccountTable={hasAccountTable}
          dualPaperView={dualPaperView}
          setDualPaperView={setDualPaperView}
          showDualViewOption={examData?.dualPaperView == 1 || examData?.dualPaperView === true || dualPaperView === true}
        />
      </Modal>
      <PrintModel
        isModelOpen={isModelPrintOpen}
        setisModelOpen={setisModelPrintOpen}
        handleModelClose={handleModelPrintClose}
        modelCall={modelCall}
        setModelCall={setModelCall}
        headerPath={HeadersPath.AutoGenerate}
        buttonText="Save"
      />
    </div>
  );
};

export default PdfPreview;
